export const LOCALES = {
  ENGLISH: 'en-us',
  UKRAINE: 'uk-ua',
};
